import { useContext } from "react";
import AuthContext from "../../../context/AuthContext";
import AdminDashboardHome from "./dashboardHomes/AdminDashboardHome";
import UsersDashboard from "./dashboardHomes/UsersDashboard";
import RiskIdentifierDashboardHome from "./dashboardHomes/RiskIdentifierDashboardHome";
import RisKManagerDashboardHome from "./dashboardHomes/RisKManagerDashboardHome";
import CartoViewerDashboardHome from "./dashboardHomes/CartoViewerDashboardHome";
import AuditManagerDashboardHome from "./dashboardHomes/AuditManagerDashboardHome";
import AuditorDashboardHome from "./dashboardHomes/AuditUserDashboardHome";



// Dashboard Home
export default function DashboardHome() {
  const { hasRole } = useContext(AuthContext);

  // Decide which dashboard to show - Priority order matters
  if (hasRole("Admin")) {
    return <AdminDashboardHome />;
  } else if (hasRole("AuditManager")) {
    return <AuditManagerDashboardHome />;
  } else if (hasRole("RiskManager")) {
    return <RisKManagerDashboardHome />;
  } else if (hasRole("AuditUser")) {
    return <AuditorDashboardHome />;
  } else if (hasRole("RiskIdentifier")) {
    return <RiskIdentifierDashboardHome />;
  } else if (hasRole("CartoViewer")) {
    return <CartoViewerDashboardHome />;
  }

  return <UsersDashboard />;
}
